/* eslint-disable default-case */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect} from 'react'
import NavigationBar from '../components/NavBar'
import VansComponent from '../components/VansComponent'
import { useSelector, useDispatch } from 'react-redux'
import {
    addVanData,
    selectVanData
} from '../features/vanData/vanDataSlice'
import {
    addImages,
    selectImages
} from '../features/imagesSliceFile/imagesSlice'
import {
    addVehicle, 
    selectVehicles
} from '../features/vehicles/vehiclesSlice'

var fuckYouReact = null

const CompanyVans = (props) => {
    // redux stuff
    const vanData = useSelector(selectVanData)
    const imageData = useSelector(selectImages)
    const vehicleData = useSelector(selectVehicles)

    const dispatch = useDispatch()

    // useEffect( () => {
    //     if (vanData.vehicles) {
    //         setVansList(vanData.vehicles)
    //         setVanWithImage(vanData)
    //     } else {
    //         let myVar = reRenderTrigger
    //         myVar++
    //         setReRenderTrigger(myVar)
    //     }
    // }, [vanData])

    var CryptoJS = require("crypto-js");

    const [ selection, setSelection ] = useState('')
    const [ content, setContent ] = useState(null)
    const [ vansList, setVansList ] = useState([])
    const [ reRenderTrigger, setReRenderTrigger ] = useState(0)
    const [ displayDiv, setDisplayDiv ] = useState('diplay_none')
    const [ letMeView, setLetMeView ] = useState('main_div_vans_none')
    const [ vanDocs, setVanDocs ] = useState([])
    const [ selectedVan, setSelectedVan ] = useState(null)
    const [ deleteForm, setDeleteForm ] = useState(null)
    const [ errorMessage, setErrorMessage ] = useState(null)
    const [ vanWithImage, setVanWithImage ] = useState([])
    const [ editType, setEditType ] = useState('')
    const [ editRegistration, setEditRegistration ] = useState('')
    const [ editMake, setEditMake ] = useState('')
    const [ editModel, setEditModel ] = useState('')
    const [ editYear, setEditYear ] = useState('')
    const [ editGate, setEditGate ] = useState(false)
    const [ reload, setReload ] = useState(false)
    const [ images, setImages ] = useState([])
    const [ vehicles, setVehicles ] = useState([])


    useEffect( () => {
        if (imageData.length > 0 && vehicleData.length > 0) {
            setImages([...imageData])
            setVehicles([...vehicleData])
        } else {
            reload ? setReload(false) : setReload(true)
        }
    }, [])

    // useEffect(() => {
    //     setDisplayDiv('display_none')
    //     async function getData(url = '') {
    //         let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
    //         let originalText = bytes.toString(CryptoJS.enc.Utf8);
    //         const response = await fetch(url, {
    //             method: 'GET', 
    //             mode: 'cors',
    //             cache: 'no-cache',
    //             credentials: 'same-origin',
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 'Authorization': `Token ${originalText}`
    //             }
    //         });

    //         return response ? response.json() : console.log('no reponse')

    //     };

    //     getData('https://backendpajamas.herokuapp.com/vandata/').then( (response) => {
    //         console.log(response)
    //         dispatch(addVanData(response.data))
    //     })
    // }, [])
        // grab the main data
        useEffect( () => {
            async function getData(url = '') {
                let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                let originalText = bytes.toString(CryptoJS.enc.Utf8);
                const response = await fetch(url, {
                    method: 'GET', 
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Token ${originalText}`
                    }
                });
    
                return response ? response.json() : console.log('no reponse')
    
            };
    
            getData('https://backendpajamas.herokuapp.com/vehicles/').then( response => {
                setVehicles(response.results)
                getData('https://backendpajamas.herokuapp.com/images/').then( response => {
                    setImages(response.results)
                })
            })
    
        }, [reload, reRenderTrigger])



            // handle mapping the data
    useEffect( () => {
        let localDriverArray = []
        let localVehicleArray = []
        if (images.length > 0 && vehicles.length > 0) {
            vehicles.forEach( vehicle => {
                let localVehicle = {...vehicle}
                localVehicle.imgArray = []
                images.forEach( image => {
                    if (`https://backendpajamas.herokuapp.com/vehicles/${vehicle.vehicle_id}/` === image.vehicle_id) {
                        localVehicle.imgArray.push(image)
                    }
                })
                localVehicleArray.push(localVehicle)
            })
        }
        setVansList(localVehicleArray)
        setVanWithImage(localVehicleArray)
    }, [images, vehicles])

    const handleSettingSelection = (van) => {
        fuckYouReact = van
    }

    // useEffect(() => {
    //     async function getData(url = '') {
    //         let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
    //         let originalText = bytes.toString(CryptoJS.enc.Utf8);
    //         const response = await fetch(url, {
    //             method: 'GET', 
    //             mode: 'cors',
    //             cache: 'no-cache',
    //             credentials: 'same-origin',
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 'Authorization': `Token ${originalText}`
    //             }
    //         });
    //         return response ? response.json() : console.log('no reponse')
    //     };

    //     getData('https://backendpajamas.herokuapp.com/vandata/').then( (response) => {
    //         dispatch(addVanData(response.data))
    //     })
    // }, [reRenderTrigger])

    // function for rerendering
    const reRenderMe = (content=null, selectedVanHere=null) => {
        setSelectedVan(selectedVanHere)
        let myVar = reRenderTrigger
        myVar++
        setReRenderTrigger(myVar)
        if (content !== null) {
            if (content === true) {
                setLetMeView('main_div_vans')
                setSelection('H2O Vans')
                setContent(true)
            } else {
                setLetMeView('main_div_vans')
                setSelection('Rental Vans')
                setContent(false)
            }
        }
    }

    // make the h2o vans option appear
    const handleH2oVansClick = () => {
        setLetMeView('main_div_vans')
        setSelection('H2O Vans')
        setContent(true)
    }
        
    // make the h2o vans option appear
    const handleRentalVansClick = () => {
        setLetMeView('main_div_vans')
        setSelection('Rental Vans')
        setContent(false)
    }

    // make the off-hire vans appear
    const handleOffHireClick = () => {
        setLetMeView('main_div_vans')
        setSelection('Off-Hire Vans')
        // setContent(false)
    }

    // return
    const handleReturn = () => {
        setDeleteForm(null)
        setEditGate(false)
        setEditMake('')
        setEditModel('')
        setEditRegistration('')
        setEditType('')
        setEditYear('')
    }

    // delete the van
    const handleDeleteVan = () => {
        async function getData(url = '') {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'DELETE', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                }
            });
        };
    
        getData(`https://backendpajamas.herokuapp.com/vehicles/${fuckYouReact.vehicle_id}/`).then( (response) => {
            let myVar = reRenderTrigger
            myVar++
            setDeleteForm(null)
            setReRenderTrigger(myVar)
        })
    }

    // get rid of error
    const handleDeleteError = () => {
        setErrorMessage(null)
    }

    // handle deletion process
    const deleteVan = () => {
        if (fuckYouReact) {
            // if (props.superUser) {
                setDeleteForm(
                    <div className='deletionForm'>
                        <h1>
                            Would you like to delete this van?
                        </h1>
                        <p className='removePadding'>Make: {fuckYouReact.make}</p>
                        <p className='removePadding'>Model: {fuckYouReact.model}</p>    
                        <p className='removePadding'>Registration: {fuckYouReact.registration}</p>   
                        <div>
                            <button className='deleteButton' onClick={handleDeleteVan}>Delete</button> 
                            <button className='returnButton' onClick={handleReturn}>Return</button> 
                        </div>
                    </div>
                )
            // } else {
            //     setErrorMessage(
            //         <div className='errorMessageAllPages'>
            //             <h3 id='errorMessage'>Must be a Super User in order to delete vans. </h3>
            //             <button className='errorButton' onClick={handleDeleteError}>Return</button>
            //         </div>
            //     )
            // }
        } else {
            setDeleteForm(
                <div className='deletionObjection'>
                    <h3>
                        Please Select a Van for Deletion
                    </h3>
                </div>
            )
            setTimeout( () => {
                setDeleteForm(null)
            }, 2000)
        }
    }

    // handle submitting edit to backend
    const handleEditSubmit = () => {
        async function putData(url = '', data = {}) {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'PUT', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
                body: JSON.stringify(data)
                });

            return response ? response.json() : console.log('no reponse')
        };
        
        putData(`https://backendpajamas.herokuapp.com/vehicles/${fuckYouReact.vehicle_id}/`, {
            make: editMake,
            vtype: editType,
            registration: editRegistration,
            year: editYear,
            model: editModel
        }).then( response => {
            reRenderMe()
            handleReturn()
        })
    }

    // handle Editing State
    const handleChange = (e) => {
        switch(e.target.name.length > 0){
            case e.target.name === 'type':
                setEditType(e.target.value)
                break;
            case e.target.name === 'reg':
                setEditRegistration(e.target.value)
                break;
            case e.target.name === 'make':
                setEditMake(e.target.value)
                break;
            case e.target.name === 'model':
                setEditModel(e.target.value)
                break;
            case e.target.name === 'year':
                setEditYear(e.target.value)
                break;
        }
    }

    // editing with state
    useEffect( () => {
        if (fuckYouReact && editGate) {
            setDeleteForm(
                <div className='deletionForm'>
                    <h1>
                        Edit {fuckYouReact.registration}
                    </h1>
                    <div className='editScreenVans'>
                        <div className='editVansInput'>
                            <h3>Type: </h3>
                            <input className='editVansInputBars' name='type' value={editType} onChange={handleChange} />
                        </div>
                        <div className='editVansInput'>
                            <h3>Registration:</h3>
                            <input className='editVansInputBars' name='reg' value={editRegistration} onChange={handleChange} />
                        </div>
                        <div className='editVansInput'>
                            <h3>Make: </h3>
                            <input className='editVansInputBars' name='make' value={editMake} onChange={handleChange} />
                        </div>
                        <div className='editVansInput'>
                            <h3>Model:</h3>
                            <input className='editVansInputBars' name='model' value={editModel} onChange={handleChange} />
                        </div>
                        <div className='editVansInput'>
                            <h3>Year:</h3>
                            <input className='editVansInputBars' name='year' value={editYear} onChange={handleChange} />
                        </div>
                    </div>
                    <div>
                        <button className='returnThree' onClick={handleEditSubmit}>Submit</button> 
                        <button className='returnTwo' onClick={handleReturn} >Return</button> 
                    </div>
                </div>
            )
        }
    }, [editType, editRegistration, editMake, editModel, editYear])

    // allow editing
    const editVan = () => {
        setEditGate(true)
        if (!fuckYouReact) {
            setDeleteForm(
                <div className='deletionObjection'>
                    <h3>
                        Please Select a Van for Edit
                    </h3>
                </div>
            )
            setTimeout( () => {
                setDeleteForm(null)
            }, 2000)
        }
        if (fuckYouReact) {
            setEditMake(fuckYouReact.make)
            setEditType(fuckYouReact.vtype)
            setEditRegistration(fuckYouReact.registration)
            setEditModel(fuckYouReact.model)
            setEditYear(fuckYouReact.year)
        }
    }

    return (
        <>
        {errorMessage}
        {deleteForm}
        <div className='home_content'>
        <NavigationBar 
            title='Company Vans' 
            superUser={props.superUser ? true : false}
            email={props.user_email}
        />
        <div className='main_content_vans'>
            <div className='top_company_vans'>
                <button className='compliance_add_driver_button_submit' onClick={handleH2oVansClick}>
                    <span className='span_in_complaince_button'>H2O Vans</span> 
                </button>
                <button className='compliance_add_driver_button_submit' onClick={handleRentalVansClick}>
                    <span className='span_in_complaince_button'>Rental Vans</span> 
                </button>
                <button className='compliance_add_driver_button_submit' onClick={handleOffHireClick}>
                    <span className='span_in_complaince_button'>Off-Hire Vans</span> 
                </button>
                <h2>{selection}</h2>
                <button className='compliance_add_driver_button_submit_almost_right' onClick={editVan}>
                    <span className='span_in_complaince_button'>Edit</span> 
                </button>
                <button className='compliance_add_driver_button_submit_right' onClick={deleteVan}>
                    <span className='span_in_complaince_button'>Delete</span> 
                </button>
            </div>
            <div className={displayDiv}>
                <VansComponent 
                    owned={content}
                    data={vansList}
                    reRender={reRenderMe}
                    viewMe={letMeView}
                    content={content}
                    selectedVan={selectedVan}
                    vanWithImage={vanWithImage}
                    selection={selection}
                    setSelection={handleSettingSelection}
                />
            </div>
        </div>
    </div>
    </>
    )
}

export default CompanyVans